export const API_GET_SECRETARY_ACTIVE = "API_GET_SECRETARY_ACTIVE";
export const API_GET_SECRETARY_ACTIVE_SUCCESS = "API_GET_SECRETARY_ACTIVE_SUCCESS";
export const API_GET_SECRETARY_ACTIVE_FAIL = "API_GET_SECRETARY_ACTIVE_FAIL";

export const API_GET_ALL_FOLDER_HELP = "API_GET_ALL_FOLDER_HELP";
export const API_GET_ALL_FOLDER_HELP_SUCCESS = "API_GET_ALL_FOLDER_HELP_SUCCESS";
export const API_GET_ALL_FOLDER_HELP_FAIL = "API_GET_ALL_FOLDER_HELP_FAIL";

export const API_GET_WAITING_FOLDER_HELP = "API_GET_WAITING_FOLDER_HELP";
export const API_GET_WAITING_FOLDER_HELP_SUCCESS = "API_GET_WAITING_FOLDER_HELP_SUCCESS";
export const API_GET_WAITING_FOLDER_HELP_FAIL = "API_GET_WAITING_FOLDER_HELP_FAIL";

export const API_GET_CREATED_FOLDER_HELP = "API_GET_CREATED_FOLDER_HELP";
export const API_GET_CREATED_FOLDER_HELP_SUCCESS = "API_GET_CREATED_FOLDER_HELP_SUCCESS";
export const API_GET_CREATED_FOLDER_HELP_FAIL = "API_GET_CREATED_FOLDER_HELP_FAIL";

export const API_GET_ASSIGNED_FOLDER_HELP = "API_GET_ASSIGNED_FOLDER_HELP";
export const API_GET_ASSIGNED_FOLDER_HELP_SUCCESS = "API_GET_ASSIGNED_FOLDER_HELP_SUCCESS";
export const API_GET_ASSIGNED_FOLDER_HELP_FAIL = "API_GET_ASSIGNED_FOLDER_HELP_FAIL";

export const API_CREATE_FOLDER_HELP = "API_CREATE_FOLDER_HELP";
export const API_CREATE_FOLDER_HELP_SUCCESS = "API_CREATE_FOLDER_HELP_SUCCESS";
export const API_CREATE_FOLDER_HELP_FAIL = "API_CREATE_FOLDER_HELP_FAIL";

export const API_MANAGE_FOLDER_HELP_WAITING_LIST = "API_MANAGE_FOLDER_HELP_WAITING_LIST";
export const API_MANAGE_FOLDER_HELP_WAITING_LIST_SUCCESS = "API_MANAGE_FOLDER_HELP_WAITING_LIST_SUCCESS";
export const API_MANAGE_FOLDER_HELP_WAITING_LIST_FAIL = "API_MANAGE_FOLDER_HELP_WAITING_LIST_FAIL";

export const API_ACCEPT_SUPPORT_FOLDER_HELP = "API_ACCEPT_SUPPORT_FOLDER_HELP";
export const API_ACCEPT_SUPPORT_FOLDER_HELP_SUCCESS = "API_ACCEPT_SUPPORT_FOLDER_HELP_SUCCESS";
export const API_ACCEPT_SUPPORT_FOLDER_HELP_FAIL = "API_ACCEPT_SUPPORT_FOLDER_HELP_FAIL";

export const API_CANCEL_FOLDER_HELP = "API_CANCEL_FOLDER_HELP";
export const API_CANCEL_FOLDER_HELP_SUCCESS = "API_CANCEL_FOLDER_HELP_SUCCESS";
export const API_CANCEL_FOLDER_HELP_FAIL = "API_CANCEL_FOLDER_HELP_FAIL";

export const API_ABORT_SUPPORT_FOLDER_HELP = "API_ABORT_SUPPORT_FOLDER_HELP";
export const API_ABORT_SUPPORT_FOLDER_HELP_SUCCESS = "API_ABORT_SUPPORT_FOLDER_HELP_SUCCESS";
export const API_ABORT_SUPPORT_FOLDER_HELP_FAIL = "API_ABORT_SUPPORT_FOLDER_HELP_FAIL";

export const API_VALIDATE_FOLDER_HELP = "API_VALIDATE_FOLDER_HELP";
export const API_VALIDATE_FOLDER_HELP_SUCCESS = "API_VALIDATE_FOLDER_HELP_SUCCESS";
export const API_VALIDATE_FOLDER_HELP_FAIL = "API_VALIDATE_FOLDER_HELP_FAIL";

export const API_DONE_FOLDER_HELP = "API_DONE_FOLDER_HELP";
export const API_DONE_FOLDER_HELP_SUCCESS = "API_DONE_FOLDER_HELP_SUCCESS";
export const API_DONE_FOLDER_HELP_FAIL = "API_DONE_FOLDER_HELP_FAIL";

export const API_GET_STATS_FOLDER_HELP = "API_GET_STATS_FOLDER_HELP";
export const API_GET_STATS_FOLDER_HELP_SUCCESS = "API_GET_STATS_FOLDER_HELP_SUCCESS";
export const API_GET_STATS_FOLDER_HELP_FAIL = "API_GET_STATS_FOLDER_HELP_FAIL";

export const API_GET_STATS_DASHBOARD = "API_GET_STATS_DASHBOARD";
export const API_GET_STATS_DASHBOARD_SUCCESS = "API_GET_STATS_DASHBOARD_SUCCESS";
export const API_GET_STATS_DASHBOARD_FAIL = "API_GET_STATS_DASHBOARD_FAIL";

export const API_POST_ASSIGN_FOLDER_HELP = "API_POST_ASSIGN_FOLDER_HELP";

export const API_POST_COMMENT_FOLDER_HELP = "API_POST_COMMENT_FOLDER_HELP";
export const API_POST_COMMENT_FOLDER_HELP_SUCCESS = "API_POST_COMMENT_FOLDER_HELP_SUCCESS";
export const API_POST_COMMENT_FOLDER_HELP_FAIL = "API_POST_COMMENT_FOLDER_HELP_FAIL";

export const API_GET_ALL_SCANS_ORDO = "API_GET_ALL_SCANS_ORDO";
export const API_GET_ALL_SCANS_ORDO_SUCCESS = "API_GET_ALL_SCANS_ORDO_SUCCESS";
export const API_GET_ALL_SCANS_ORDO_FAIL = "API_GET_ALL_SCANS_ORDO_FAIL";

export const API_GET_STATS_SECRETARY_HOME = "API_GET_STATS_SECRETARY_HOME";
export const API_GET_STATS_SECRETARY_HOME_SUCCESS = "API_GET_STATS_SECRETARY_HOME_SUCCESS";
export const API_GET_STATS_SECRETARY_HOME_FAIL = "API_GET_STATS_SECRETARY_HOME_FAIL";

export const API_PATCH_NOTIFY_PREREGISTER = "API_PATCH_NOTIFY_PREREGISTER";

export const API_GET_CANCEL_REASONS = "API_GET_CANCEL_REASONS";
export const API_GET_CANCEL_REASONS_SUCCESS = "API_GET_CANCEL_REASONS_SUCCESS";
export const API_GET_CANCEL_REASONS_FAIL = "API_GET_CANCEL_REASONS_FAIL";

export const API_SEND_EMAIL_INCOMPLETE_FOLDER = "API_SEND_EMAIL_INCOMPLETE_FOLDER";
export const API_SEND_EMAIL_INCOMPLETE_FOLDER_SUCCESS = "API_SEND_EMAIL_INCOMPLETE_FOLDER_SUCCESS";
export const API_SEND_EMAIL_INCOMPLETE_FOLDER_FAIL = "API_SEND_EMAIL_INCOMPLETE_FOLDER_FAIL";

export const API_GET_ALL_SECRETARIES = "API_GET_ALL_SECRETARIES";
export const API_GET_ALL_SECRETARIES_SUCCESS = "API_GET_ALL_SECRETARIES_SUCCESS";
export const API_GET_ALL_SECRETARIES_FAIL = "API_GET_ALL_SECRETARIES_FAIL";

export const API_GET_SEC_SUPPORTED_FOLDERS = "API_GET_SEC_SUPPORTED_FOLDERS";
export const API_GET_SEC_SUPPORTED_FOLDERS_SUCCESS = "API_GET_SEC_SUPPORTED_FOLDERS_SUCCESS";
export const API_GET_SEC_SUPPORTED_FOLDERS_FAIL = "API_GET_SEC_SUPPORTED_FOLDERS_FAIL";
